export const timeline = () => {
    const heroTimelineModules = document.querySelectorAll('.m__hero--has-timeline');

    if ( heroTimelineModules ) {
        heroTimelineModules.forEach(mod => {
            const tlItems = mod.querySelectorAll('.m__hero__overlay-timeline-item');
            const progressElement = mod.querySelector('.m__hero__overlay-timeline-progress');
            const video = mod.querySelector('.js__tl-video');
            let progressPercentage = 0;
            
            video.addEventListener('timeupdate', () => {
                const { duration, currentTime } = video;
        
                // Calculate the progress percentage
                progressPercentage = (currentTime / duration) * 100;

                // Calculate the transition duration based on the remaining time to the end of the video
                const remainingTime = duration - currentTime;
                const transitionDuration = remainingTime * 0.1; // You can adjust the factor as needed

                // Update the progress element with smooth animation
                if ( transitionDuration >= 0.25 ) { // Don't let the transition duration get too low or it becomes janky!
                    progressElement.style.transitionDuration = `${transitionDuration}s`;
                }
                progressElement.style.transform = `translateX(${progressPercentage}%)`;

                // Update the active tl item class
                tlItems.forEach(item => {
                    const itemPercentageMin = parseInt(item.getAttribute('data-percentage-min'));
                    const itemPercentageMax = parseInt(item.getAttribute('data-percentage-max'));

                    if ( progressPercentage > itemPercentageMin && progressPercentage < itemPercentageMax) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });
            });

            // Add an ended event listener to reset the progress and play the video again
            video.addEventListener('ended', () => {
                // Remove Active class from the active tl item
                // mod.querySelectorAll('.m__hero__overlay-timeline-item.active').classList.remove('active');

                // Remove the style attribute to force the progress bar bac to 0 without animating
                progressElement.removeAttribute('style');

                video.currentTime = 0; // Reset the video to the beginning
                video.play(); // Play the video again
            });

            // Play the video
            video.play();
        });
    }
}